import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from '../hooks/useTranslation';
import styles from './ProgressBar.module.css';

function ProgressBar({ currentStep, onStepClick, providerType = 'hair' }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const steps = [
    { number: 1, labelKey: 'signup.progressStep1', path: `/signup/${providerType}` },
    { number: 2, labelKey: 'signup.progressStep2', path: `/signup/${providerType}?step=2` },
    { number: 3, labelKey: 'signup.progressStep3', path: '/signup/payment' },
  ];

  const handleStepClick = (step) => {
    if (step.number < currentStep && onStepClick) {
      // Permettre de revenir en arrière uniquement
      if (step.number === 1) {
        navigate(`/signup/${providerType}`);
      } else if (step.number === 2) {
        navigate(`/signup/${providerType}?step=2`);
      } else if (step.number === 3) {
        navigate('/signup/payment');
      }
      if (onStepClick) {
        onStepClick(step.number);
      }
    }
  };

  return (
    <div className={styles.progressBar}>
      <div className={styles.progressSteps}>
        {steps.map((step, index) => {
          const isActive = currentStep === step.number;
          const isCompleted = currentStep > step.number;
          const isClickable = step.number < currentStep;
          // La ligne avant cette étape est complétée si cette étape ou une précédente est complétée
          const previousLineCompleted = isCompleted || (isActive && index > 0);

          return (
            <div 
              key={step.number} 
              className={`${styles.progressStep} ${previousLineCompleted ? styles.completed : ''}`}
            >
              {/* Cercle de l'étape */}
              <button
                type="button"
                className={`${styles.stepCircle} ${
                  isActive ? styles.active : ''
                } ${isCompleted ? styles.completed : ''} ${
                  isClickable ? styles.clickable : ''
                }`}
                onClick={() => handleStepClick(step)}
                disabled={!isClickable}
                aria-label={t('signup.progressStepAria', { step: step.number, label: t(step.labelKey) })}
              >
                {isCompleted ? '✓' : step.number}
              </button>

              {/* Label de l'étape */}
              <span
                className={`${styles.stepLabel} ${
                  isActive ? styles.active : ''
                }`}
              >
                {t(step.labelKey)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  onStepClick: PropTypes.func,
  providerType: PropTypes.string,
};

export default ProgressBar;

